import { type UseQueryResult, useQuery } from 'react-query';
import { ElectionList } from '../../constants/common';
import { ParticipantTaskSharedService } from '../../services/wealthlane-award-services';

const useGetPsuElectionMethodSetting = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const PsuElectionMethodSetting = useQuery(
    ['getPsuElectionMethodSetting'],
    async () => {
      return await handleRequest(
        ParticipantTaskSharedService.getApiAwardApiAppParticipantTaskPSUElectionMethodSetting()
      );
    },
    {
      select: (data: any) => {
        return data?.settlementTypes?.map((item: any) => {
          return {
            label: item.settlementType ?? '',
            value: item.settlementTypeId ?? '',
          };
        });
        // if (data != null) {
        //   console.log("data", data);

        //   const filterData = ElectionList.filter((item) => data[item.value] !== false);
        //   return filterData;
        // }
      },
    }
  );

  return PsuElectionMethodSetting;
};

export default useGetPsuElectionMethodSetting;
